import {httpClientV2} from "../../../../infrastructure/http";
import {ProfileStatus} from "../../domain/ProfileStatus";
import {ProfileStatusRepository} from "../../domain/repository";
import {ProfileStatusMapperV2} from "../mappers/mapper.v2";
import {V2GetProfileStatusApiResponse} from "../mappers/mapper.types";

export class ProfileStatusRepositoryV2 implements ProfileStatusRepository {
  private readonly endpoint = "profile/status";

  async getStatus(): Promise<ProfileStatus> {
    const response = await httpClientV2.get<V2GetProfileStatusApiResponse>(this.endpoint);
    return ProfileStatusMapperV2.toDomain(response.data ?? {});
  }
}
